import { render, staticRenderFns } from "./AgentSidebar.vue?vue&type=template&id=8e1ac9ae&scoped=true&"
import script from "./AgentSidebar.vue?vue&type=script&lang=js&"
export * from "./AgentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1ac9ae",
  null
  
)

export default component.exports